export default function isInitRegisterBtn(userInfo?: any) {
    if (userInfo) {
        let registerBtn = document.querySelectorAll('.btn-register');
        for (let i = 0, len = registerBtn.length; i < len; i++) {
            const ele = registerBtn[i] as HTMLElement;
            ele.style.display = 'none';
        }

        let registerText = document.querySelectorAll('.text-register');
        if (registerText && registerText.length > 0) {
            for (let i = 0, len = registerText.length; i < len; i++) {
                const ele = registerText[i] as HTMLElement;
                ele.style.display = 'none';
            }
        }
    }
}
